import { ApolloProvider } from '@apollo/client';
import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import React from 'react';
import { render } from 'react-dom';
import TagManager from 'react-gtm-module';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import {
  BrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import config from '../config/default.json';
import App from './App';
import getMainSiteLocation from './helpers/getMainSiteLocation';
import injectQubitScript from './helpers/injectQubitScript';
import client from './lib/apolloClient';
import queryClient from './lib/queryClient';

const { isDevelopment, gtmEnvironment, gtmAuth, gtmId, dataLayerName } = config;

const tagManagerArgs = {
  gtmId,
  dataLayerName,
  ...(gtmEnvironment && { preview: gtmEnvironment }),
  ...(gtmAuth && { auth: gtmAuth }),
};

const mainSiteLocation = getMainSiteLocation(config, window.location.origin);

const appName = 'web-app-checkout';

initializeFaro({
  url: config.grafanaFaroApmUrl,
  app: {
    name: appName,
    environment: mainSiteLocation?.env ?? 'dev',
  },
  sessionTracking: {
    samplingRate: 1,
    persistent: true,
  },
  instrumentations: [
    ...getWebInstrumentations(),

    new ReactIntegration({
      router: createReactRouterV6Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType,
      }),
    }),
  ],
});

TagManager.initialize(tagManagerArgs);

injectQubitScript();

render(
  <ApolloProvider client={client}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {isDevelopment && <ReactQueryDevtools />}
    </QueryClientProvider>
  </ApolloProvider>,

  // eslint-disable-next-line no-undef
  document.getElementById('checkout'),
);
